/**
 * Cache key for an icon rendered to markup. It must include every prop that changes the markup: icons that share a
 * name, like the sleeping moon and the sleep-check badge, are told apart only by these.
 */
export const iconPropsToCacheKey = ({ icon, color, fill, transparent, size }) => `${icon}_${color}_${fill}_${transparent}_${size}`;
